import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import moment from 'moment';
import { enumValueNormalizer } from '@/helpers/enum_value_normalizer';
let MerchantDetails = class MerchantDetails extends Mixins(ViewportSizeMixin) {
    goToMiniApp(fbPageId) {
        window.open(`https://m.me/${fbPageId}`, '_blank');
    }
    formattedLaunchedDate(date) {
        const launchDate = new Date(date);
        return moment(launchDate).format('LLL');
    }
    customSvgBtnIcon(fileName) {
        // eslint-disable-next-line import/no-dynamic-require
        return require(`@/assets/images/${fileName}.svg`);
    }
    get isSettings() {
        return this.$route.name === 'reseller-specific-merchant-settings';
    }
    get isDetails() {
        return this.$route.name === 'reseller-specific-merchant-details';
    }
    get isBillings() {
        return this.$route.name === 'reseller-specific-merchant-billings';
    }
    goToBillingHistory(uuid) {
        this.$router.push({
            name: 'reseller-specific-merchant-billings',
            params: { merchantUuid: uuid },
        });
    }
    humanizedPlanType(planType) {
        return enumValueNormalizer(planType);
    }
};
__decorate([
    Prop({ type: Object, required: true })
], MerchantDetails.prototype, "app", void 0);
__decorate([
    Prop({ type: String, required: true })
], MerchantDetails.prototype, "header", void 0);
MerchantDetails = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], MerchantDetails);
export default MerchantDetails;
